import { useCallback, useState } from "react";
import type { DashboardSort, SortOrder } from "./useDashboards";

/** Both dashboard lists use the same sort transitions while retaining their default order. */
export function useDashboardSort(initialSort: DashboardSort, initialOrder: SortOrder) {
  const [sorting, setSorting] = useState({ sort: initialSort, order: initialOrder });
  const onSort = useCallback((sort: DashboardSort) => {
    setSorting((current) => ({
      sort,
      order:
        sort === current.sort
          ? current.order === "asc"
            ? "desc"
            : "asc"
          : sort === "updated_at"
            ? "desc"
            : "asc",
    }));
  }, []);
  return { ...sorting, onSort };
}
